<template>
  <div class="upload bg-white"  @click="hidedraft()">
    <!-- <router-view/> -->
    <headerCom>
      <div class="flex-lm">
        <div class="work-acts flex-lm white-font font-size14">
             <div class="flex-cm work-act-single white-font font-size14" style="position: relative;" @mouseenter="showwechat" @mouseleave="hidewechat">
                <div class="bg-green botton-content flex-cm">
                  <img src="https://assets.pfotoo.com/pc/img/upload.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
                  <span>同步至公众号</span>
                </div>
               <wechat :id="workidstr" :show="wechatshow" :uploadtype="1"></wechat>
             </div>
            <!-- <div class="flex-cm work-act-single white-font font-size14" style="position: relative;" @mouseenter="showgroup" @mouseleave="hidegroup">
              <div class="bg-green botton-content flex-cm">
                <img src="https://assets.pfotoo.com/pc/img/move.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
                <span>批量移动</span>
              </div>
              <group :cid="draftinfo.id" :show="addshow" v-if="draftinfo.id" :id="workidstr"></group>

            </div> -->
        </div>
      </div>
    </headerCom>
    <div :style="{minHeight:minHeight+'px'}">
      <!-- <img src="https://assets.pfotoo.com/pc/img/nothing.svg"/>
      <div class="gray-font font-size14" style="padding: 10px 0px 20px;">暂无征稿</div>
      <a class="green-font font-size14 flex-cm" style="width: 130px; height: 30px; border-radius: 15px; border: 1px solid rgb(61, 196, 167); cursor: pointer;" href="https://support.qq.com/product/57964" target="_blank">去提需求</a> -->
      <div class="upload-top">
          <draftcover ref="collectcover" v-on:getdraftid="getdraftid"></draftcover>
          <div class="flex-lr" style="padding-top:23px;padding-left: 20px;padding-right: 35px;box-sizing: border-box;align-items:flex-start;">
            <!-- tab相册 -->
            <tab :id="id" :auto="false" v-on:tellgroup="tellgroup" v-if="id!=''"></tab>
            <div class="flex-rr" @click="selectall" style="width: 60px;height: 28px;">
              <div :class="['checkbox flex-cm',allselect ? 'bg-green' : '']">
                <img src="https://assets.pfotoo.com/pc/img/right-white.svg" style="width:21px;height:21px;margin-left:-2px;position: relative;top:-2px;" v-if="allselect"/>
              </div>
              <div class="black-font font-size14">全选</div>
            </div>
          </div>
          <div class="upload-unit-list flex-lm">
            <div :class="['detail-unit-single  font-size14 flex-cm',item.isactive ? 'green-font unit-green-font' : 'gray-font']" v-for="(item,index) in unitlist" :key="index" @click="selectunit(index)">{{item.name}}</div>
          </div>
        </div>
        <div class="detail-content flex-rs" v-if="showlist.length>0">
          <work v-for="(item,index) in showlist" :key="index" :item="item" :index="index" v-on:tellworkidx="showbigimages" v-on:selectwork="selectsingle" :type="draftinfo.type ? draftinfo.type : 1"></work>
        </div>
        <div class="flex-vc" :style="{minHeight:minHeight-200+'px'}" v-else>
          <img src="https://assets.pfotoo.com/pc/img/nothing.svg"/>
          <div class="gray-font font-size14 flex-vc" style="padding: 10px 0px 20px;">
            <div>你还没有添加投稿到相册</div>
            <div>添加到相册的投稿将会出现在这里</div>
          </div>
          <!-- <div class="green-font font-size14 flex-cm" style="width: 130px; height: 30px; border-radius: 15px; border: 1px solid rgb(61, 196, 167); cursor: pointer;" @click="invite(id)">邀请投稿</div> -->
        </div>
        <div class="work-cover fixed left right top bottom" :style="{visibility: showcover,}" v-if="showimages.length>0">
          <div class="work-cover-top flex-lr">
            <div class="white-font font-size16 font-more" style="width: 80%; display: block;">{{showimages[showindex].name}}</div>
            <div class="flex-rr">
              <div class="download-icon flex-cm" @mouseenter="showwechat" @mouseleave="hidewechat" style="cursor: pointer;padding:0 30px;">
                <img src="https://assets.pfotoo.com/icon/upload2.svg"/>
                <wechat :id="showimages[showindex].id" :show="wechatshow" :uploadtype="showimages[showindex].exif.type ? (showimages[showindex].exif.type==2 ? 3 : 2) : (draftinfo.type==2 ? 3 : 2)"></wechat>
              </div>
              <a class="download-icon" :href="'https://pfotoo.com?s=App.Qiniu.Down'+getsign()+'&id='+showimages[showindex].id">
                <img src="https://assets.pfotoo.com/icon/pc%E4%B8%8B%E8%BD%BD.svg"/>
                <div class="white-font font-size14 flex-cm down-load-hover">下载</div>
              </a>
              <img src="https://assets.pfotoo.com/icon/pc%E5%85%B3%E9%97%AD.svg" style="margin-left:30px;" @click="close"/>
            </div>
          </div>
          <div id="swiper" class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide flex-cm" v-for="(item,index) in showimages" :key="index" :style="{left:item.left,}">
                <video controls="controls" v-if="draftinfo.type==2" class="flex-cm" :id="'video'+item.id" :poster="item.comurl" :src="item.url" :preload="index==showindex ? true : false">
                </video>
                <video controls="controls" v-else-if="draftinfo.type==3 && item.exif.type==2" class="flex-cm" :id="'video'+item.id" :poster="item.comurl" :src="item.url" :preload="index==showindex ? true : false">
                </video>
                <div class="swiper-bg flex-vc work-font-cover" v-else-if="draftinfo.type==4">
                  <div class="work-font-content white-font font-size18">{{item.exif.text}}</div>
                </div>
                <div class="swiper-bg" :style="{background:'url('+item.comurl+') center center / contain no-repeat'}" v-else></div>
              </div>
            </div>
            <div class="swiper-button-prev swiper-button flex-cm" @click="previmage" :style="{visibility: showindex>0 && showcover!='hidden' ? 'visible' : 'hidden'}">
              <img src="https://assets.pfotoo.com/icon/pc%E5%B7%A6%E7%AE%AD%E5%A4%B4.svg"/>
            </div>
            <div class="swiper-button-next swiper-button flex-cm" @click="nextimage" :style="{visibility: showindex<showimages.length-1 && showcover!='hidden' ? 'visible' : 'hidden'}">
              <img src="https://assets.pfotoo.com/icon/pc%E5%8F%B3%E7%AE%AD%E5%A4%B4.svg"/>
            </div>
          </div>
        </div>
    </div>
  </div>

</template>

<script>
  import headerCom from '../header.vue'
  import group from '../group.vue'
  import wechat from '../wechat.vue'
  import draftcover from '../draftcover.vue'
  import tab from '../tab.vue'
  import work from '../work.vue'
  export default {
    name: 'upload',
    data () {
        return {
          id:0,
          openid:JSON.parse(localStorage.getItem('userinfo')).openid,
          draftinfo:{},
          minHeight:window.innerHeight-82,
          listconfig:{},
          type:'',
          showlist:[],
          allselect:false,
          selectids:[],
          strselectids:'',
          workidstr:'',
          unitlist:[],
          unit:'',
          code:'',
          showimages:[],
          showcover:'hidden',
          showindex:0,
          isRouterAlive:true,
          addshow:false,
          wechatshow:false,
          draftpage:1,
          draftlist:[],
          draftHidden:true,
          load:false,
          end:false,
        }
      },
      components:{
        headerCom,
        group,
        wechat,
        draftcover,
        tab,
        work
      },
      methods:{
        getsign(){
           return this.$getsign();
        },
        getdetail(){
         this.$http({
           url:'https://pfotoo.com?s=App.Contribution.GetContributionById'+this.$getsign(),
           params:{
             id:this.id,
             openid:this.openid
           },
           method:'POST',
           headers: {
             'Content-Type': 'application/x-www-form-urlencoded'
           }
         }).then((res)=>{
           console.log(res.body)
           let json=res.body;
           if(res.body.ret==200){
              console.log(json)
              this.draftinfo=json.data.contribution[0];
              this.unitlist=[];
              if(json.data.contribution[0].theme!='不限题材'){
                let arr=json.data.contribution[0].theme.split(',');
                arr.forEach((v,i)=>{
                  this.unitlist.push({
                    name:v,
                    isactive:false
                  })
                })
              }
           }
         })
       },
       isupload(){
         if(this.selectids.length>0){
            if(this.openlist.length>0){
                if(this.openlist.length==1){
                  this.upload(this.openlist[0].authorizer_appid);
                }else{
                  this.wechatshow=true;
                }
            }else{
              this.$router.push({
                path:'setting'
              })
            }
         }else{
            this.$message({
                showClose: true,
                message: '请选择投稿'
            });
         }
       },
       upload(appid){
         this.$http({
           url:'https://pfotoo.com?s=App.Open.UploadFile'+this.$getsign(),
           params:{
             authorizer_appid:appid,
             type:1,
             id:this.workidstr,
           },
           method:'POST',
           headers: {
             'Content-Type': 'application/x-www-form-urlencoded'
           }
         }).then((res)=>{
           console.log(res.body)
           let json=res.body;
           if(res.body.ret==200){
              this.$message({
                  message: '所选作品已上传至公众号',
                  type: 'success'
              });
           }
         })

       },
       showgroup(){
         console.log('uuuuuu')
         this.addshow=true;
       },
       hidegroup(){
         this.addshow=false;
       },
       showwechat(){
         this.wechatshow=true;
       },
       hidewechat(){
         this.wechatshow=false;
       },
       getgrouplist(){
         let paramdata={
          id:this.listconfig[this.type].id,
          openid:this.openid,
          page:this.listconfig[this.type].page,
          size:10
         }
         if(this.unit!=''){
           paramdata.unit=this.unit
         }
         this.$http({
           url:'https://pfotoo.com?s=App.Contribution.GetGroupByWorks'+this.$getsign(),
           params:paramdata,
           method:'POST',
           headers: {
             'Content-Type': 'application/x-www-form-urlencoded'
           }
         }).then((res)=>{
           console.log(res.body)
           let json=res.body;
           if(res.body.ret==200){
              this.marklist(json);
           }
         })
       },
       marklist(json){
        if(JSON.stringify(json.data)!="{}"){
          json.data.forEach((v,i)=>{
            if(i%3==0){
              v.bg='bg-blue'
            }
            if(i%3==1){
              v.bg='bg-yellow'
            }
            if(i%3==2){
              v.bg='bg-pink'
            }
            if(v.images && v.images.length>0){
              v.images.forEach((r,n)=>{
                v.isselect=false;
                if(typeof r.exif=='string'){
                  r.exif=JSON.parse(r.exif)
                }
                if(r.exif.width){
                  r.width=Number(r.exif.width);
                  r.height=Number(r.exif.height);
                  if(this.draftinfo.type==2){
                    r.comurl=r.url+'?vframe/jpg/offset/1/w/'+r.width+'/h/'+r.height;
                  }else{
                    if(this.draftinfo.type==3){
                        if(r.exif.type==2){
                          r.comurl=r.url+'?vframe/jpg/offset/1/w/'+r.width+'/h/'+r.height;
                        }else{
                          r.comurl=r.url+'?imageMogr2/thumbnail/1000x/quality/100';
                        }
                    }else{
                      r.comurl=r.url+'?imageMogr2/thumbnail/1000x/quality/100';
                    }

                  }
                  if(n==0){
                    //宽度为准
                    if(r.width*240/200>=r.height){
                      let showheight=r.height*200/r.width;
                      v.bottom=(240-showheight)/2+10;
                      v.right=10
                    }else{
                      let showwidth=240*r.width/r.height;
                      v.right=(200-showwidth)/2+10;
                      v.bottom=10;
                    }
                  }
                }
              })
            }
            if(this.allselect){
              this.allselect=false;
            }
          })
          if(this.listconfig[this.type].page==1){
            this.showlist=json.data;
          }else{
            this.showlist=this.showlist.concat(json.data)
          }
          console.log(this.showlist)
        }else{
          if(this.listconfig[this.type].page==1){
            this.showlist=[];
          }
          this.listconfig[this.type].end=true;
        }
        this.listconfig[this.type].loaded=true;
       },
       selecttab(index){
        let tablist=this.tablist;
        tablist.forEach((v,i)=>{
          if(i==index && !v.isactive){
            v.isactive=true;
            this.type=v.type;
            if(v.type!='new' && v.type!='hot'){
              this.groupid=v.id;
            }else{
              this.groupid=0;
            }
            this.listconfig[this.type]={
              id:v.id ? v.id : this.id,
              page:1,
              end:false,
              loaded:false
            }
            this.getgrouplist();
          }else{
            if(i!=index){
              v.isactive=false
            }
          }
        })
        this.tablist=this.tablist;
       },
       hidedraft(){
         console.log('rrrrrrrr')
         this.$refs.collectcover.closedraft();
       },
       getdraftid(obj){
         console.log(obj)
         this.id=obj.id;
         this.hidedraft();
         this.getdetail();
       },
       tellgroup(obj){
         console.log(obj,'ffffff');
         this.type=obj.type;
         this.listconfig[obj.type]={
           id:obj.groupid,
           page:1,
           loaded:false,
           end:false,
         };
         this.getgrouplist();
       },
       selectunit(index){
          this.unitlist.forEach((v,i)=>{
            if(index==i){
              v.isactive=!v.isactive;
              this.unitlist[index].isactive=v.isactive;
              this.unit=v.isactive ? v.name : '';
              this.listconfig[this.type]={
                id:v.id ? v.id : this.id,
                page:1,
                end:false,
                loaded:false
              }
              if(this.type=='new'){
                this.getnewlist();
              }else{
                if(this.type=='hot'){
                  this.gethotlist();
                }else{
                  this.getgrouplist();
                }
              }
            }else{
              if(v.isactive==true){
                v.isactive=false;
                this.unitlist[index].isactive=false;
              }
            }

          })
       },
       handleScroll(){
         console.log('rrrr')
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          console.log(scrollTop)
          if(this.showlist.length>0){
            if($('.work-single').length>0){
              let lasttop=$('.work-single').eq(this.showlist.length-1).offset().top;
              console.log(lasttop,'llllll',lasttop-window.innerHeight,!this.listconfig[this.type].end, this.listconfig[this.type].loaded)
              if(scrollTop>=lasttop-window.innerHeight && !this.listconfig[this.type].end && this.listconfig[this.type].loaded){
                this.listconfig[this.type].loaded=false;
                this.listconfig[this.type].page+=1;
                this.getgrouplist();
              }
            }

          }
       },
       selectsingle(obj){
         let id=obj.id,index=obj.index;
         let showlist=this.showlist;
         this.showlist[index].isselect=!this.showlist[index].isselect;
         if(this.showlist[index].isselect){
           this.selectids.push(this.showlist[index].id)
         }else{
           this.selectids=this.selectids.filter((item,index)=>{
             return item!=id
           })
         }
         console.log('dfdffff',this.selectids)
         let strarr=[];
         this.showlist.forEach((v,i)=>{
           this.selectids.forEach((r,n)=>{
             if(r==v.id){
               if(v.images.length>0){
                v.images.forEach((r1,n1)=>{
                  strarr.push(r1.id)
                })
               }

             }
           })
         })
         this.strselectids=strarr.toString();
         this.workidstr=this.selectids.toString();
         let count=0;
         showlist.forEach((v,i)=>{
           if(v.isselect){
             count++;
           }
         })
         if(count==showlist.length){
           this.allselect=true;
         }else{
           this.allselect=false;
         }
       },
       selectall(){
         this.allselect=!this.allselect;
         let showlist=this.showlist;
         showlist.forEach((v,i)=>{
           if(this.allselect==true){
             v.isselect=true;
             this.selectids.push(this.showlist[i].id);
           }else{
             v.isselect=false;
             this.selectids=this.selectids.filter((item,index)=>{
               return item!=this.showlist[index].id;
             })
           }
         })
         console.log(this.selectids)
         let strarr=[];
         if(this.allselect){
           this.showlist.forEach((v,i)=>{
             this.selectids.forEach((r,n)=>{
               if(r==v.id){
                 if(v.images.length>0){
                  v.images.forEach((r1,n1)=>{
                    strarr.push(r1.id)
                  })
                 }
               }
             })
           })
           // if(showlist.length>10){
           //   this.allselect=false;
           //   this.$message({
           //       showClose: true,
           //       message: '单次下载最多不能超过10个征稿'
           //   });
           // }
         }
         this.strselectids=strarr.toString();
         this.workidstr=this.selectids.toString();
         this.showlist=showlist;
       },
       getallimages(){
         this.showimages=[];
          this.showlist.forEach((v,i)=>{
            if(v.images.length>0){
                v.images.forEach((r,n)=>{
                  console.log(r)
                  r.left=0;
                  r.name=v.name;
                  this.showimages.push(r)
                })
            }
          })
       },
       showbigimages(index){
         console.log(this.showimages,index)
         let border=0;
         this.showlist.forEach((v,i)=>{
            if(i<index){
              v.images.forEach((r,n)=>{
                border++;
              })
            }
         })
         this.getallimages();
         this.showimages.forEach((v,i)=>{
           if(i<border){
             v.left='-100%'
           }
           if(i>border){
             v.left='100%';
           }
           if(i==border){
             v.left=0;
           }
         })
         let count=0;
         this.showlist.forEach((v,i)=>{
           if(i<index){
             if(v.images.length>0){
               v.images.forEach((r,n)=>{
                count++;
               })
             }
           }
         })
         this.showindex=count;
         this.showimages=this.showimages;
         // console.log($('video').eq(index),'tttttttt')
         let t=setInterval(()=>{
          this.showcover='visible';
          clearInterval(t);
          if(this.draftinfo.type==2){
            $('#video'+this.showimages[this.showindex].id)[0].play();
          }
          if(this.draftinfo.type==3){
            if(this.showimages[this.showindex].exif.type==2){
              $('#video'+this.showimages[this.showindex].id)[0].play();
            }
          }
         },500)
       },
       previmage(){
          console.log()
          if(this.showindex>=1){
            if(this.draftinfo.type==2){
              $('#video'+this.showimages[this.showindex].id)[0].pause();
            }
            this.showindex--;
            if(this.draftinfo.type==2){
              $('#video'+this.showimages[this.showindex].id)[0].play();
            }
            if(this.draftinfo.type==3){
              if(this.showimages[this.showindex].exif.type==2){
                $('#video'+this.showimages[this.showindex].id)[0].play();
              }
            }
            this.showimages[this.showindex].left=0;
            this.showimages[this.showindex+1].left='100%';
          }
       },
       nextimage(){
         if(this.showindex<this.showimages.length-1){
           if(this.draftinfo.type==2){
             $('#video'+this.showimages[this.showindex].id)[0].pause();
           }
           this.showindex++;
           if(this.draftinfo.type==2){
             $('#video'+this.showimages[this.showindex].id)[0].play();
           }
           if(this.draftinfo.type==3){
             if(this.showimages[this.showindex].exif.type==2){
               $('#video'+this.showimages[this.showindex].id)[0].play();
             }
           }
           this.showimages[this.showindex].left=0;
           this.showimages[this.showindex-1].left='-100%';
         }
       },
       showhidework(){
          if(this.selectids.length>0){
            this.$confirm('确定要隐藏所选择的作品吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.sethidework();
            }).catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消'
              // });
            });
          }else{
            this.$message({
                showClose: true,
                message: '请选择要隐藏的作品'
            });
          }
       },
       delrealwork(){
        this.$http({
          url:'https://pfotoo.com?s=App.Works.DelWorks'+this.$getsign(),
          params:{
            id:this.selectids.toString(),
          },
          method:'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          console.log(res.body)
          let json=res.body;
          if(res.body.ret==200){
            this.$message({
               message: '删除成功',
               type: 'success'
           });
           this.selectids=[];
           this.strselectids='';
           this.showlist=[];
           this.listconfig[this.type]={
             id:this.listconfig[this.type].id,
             page:1,
             end:false,
             loaded:false
           }
           this.getgrouplist();
          }
        })
       },
       sethidework(){
         if(this.selectids.length>0){
           this.$http({
             url:'https://pfotoo.com?s=App.Contribution.SetEventHide'+this.$getsign(),
             params:{
               submissionIdList:this.selectids,
             },
             method:'POST',
             headers: {
               'Content-Type': 'application/x-www-form-urlencoded'
             }
           }).then((res)=>{
             console.log(res.body)
             let json=res.body;
             if(res.body.ret==200){
               this.listconfig[this.type]={
                 id:this.groupid && this.groupid!=0 ? this.groupid : this.id,
                 page:1,
                 end:false,
                 loaded:false
               }
               if(this.type=='new'){
                 this.getnewlist();
               }else{
                 if(this.type=='hot'){
                   this.gethotlist();
                 }else{
                   this.getgrouplist();
                 }
               }
                this.$message({
                    message: '投稿已隐藏',
                    type: 'success'
                });
             }
           })
         }
        },
       download(){
         if(this.selectids.length>5){
           this.$message({
               showClose: true,
               message: '单次下载最多不能超过5个投稿'
           });
         }else{
           this.$message({
               showClose: true,
               message: '请选择投稿'
           });
         }
       },
       close(){
         if(this.draftinfo.type==2){
           $('#video'+this.showimages[this.showindex].id)[0].pause();
         }else{
           if(this.draftinfo.type==3){
             if(this.showimages[this.showindex].exif.type==2){
               $('#video'+this.showimages[this.showindex].id)[0].pause();
             }
           }
         }
         this.showcover='hidden';
       },
        back(){
          this.$router.go(-1);//返回上一层
        },
      },
      mounted(){
        // this.getdraftlist();
        window.addEventListener('scroll', this.handleScroll);
      },

    }
</script>

<style>
  .upload-top {
      width: 100%;
      padding:0 0 30px 15px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
  }
  .detail-menu-single {
      width: 90px;
      height: 26px;
      border-radius: 16px;
      margin-right: 30px;
      cursor: pointer;
      font-weight: 500;
  }
  .gray-border {
      border: 1px solid #bfc3c2;
  }
  .green-border {
      border: 1px solid #3dc4a7;
  }
  .checkbox {
      width: 16px;
      height: 16px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      margin-right: 6px;
      cursor: pointer;
  }
  .upload-unit-list {
      width: 100%;
      padding-top: 18px;
      padding-left: 35px;
      padding-right: 15px;
      box-sizing: border-box;

  }
  .detail-unit-single {
      margin-right: 30px;
      line-height: 20px;
      padding: 5px 0;
      cursor: pointer;
      font-weight: 500;
  }
  .unit-green-font {
      border-bottom: 1px solid #3dc4a7;
  }
  .work-cover {
      background: rgba(0,0,0,.8);
      z-index: 100;
  }
  .work-cover-top {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 60px;
      padding: 0 40px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      background: #1a2e3b;
      z-index: 2;
  }
  .work-cover-top img {
      width: 24px;
      height: 24px;
      cursor: pointer;
  }
  .down-load-hover {
      width: 44px;
      height: 25px;
      position: absolute;
      top: 50px;
      left: -10px;
      border-radius: 4px;
      background: rgba(0,0,0,.6);
      display: none;
      text-align: center;
      line-height: 25px;
  }
  .download-icon:hover .down-load-hover{
      display: block;
  }
  .download-icon {
      display: block;
      position: relative;
  }
  .swiper-container {
      width: 94%;
      height: 100%;
      position: relative;
      margin: 0 auto;
  }
  .swiper-wrapper {
      position: absolute;
      left: 0;
      top: 60px;
      bottom: 0;
      width: 100%;
      overflow: hidden;
  }
  .swiper-slide {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      -webkit-transition: left .4s ease-in .1s;
      transition: left .4s ease-in .1s;
  }
  .swiper-bg {
      width: 90%;
      height: 96%;
  }
  .swiper-button {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      width: 40px;
      height: 100%;
      cursor: pointer;
  }
  .swiper-button-prev {
      left: 0;
  }
  .swiper-button-next {
      right: 0;
  }
  .swiper-button img {
      width: 25px;
  }
  .draft-all{
    width: 100%;
    position: relative;
    z-index:10;
  }
  .draft-cover{
    width: 100%;
    position: absolute;
    left:0;
    top:50px;
    max-height: 0;
    overflow-y: hidden;
    transition: max-height .4s ease;
  }
  .draft-cover.active{
    padding-top:30px;
    max-height:600px;
    overflow-y: scroll;
    box-sizing: border-box;
  }
  .draft-list{
    padding-top:20px;
  }
  .draft-title{
    height: 50px;
    line-height: 50px;
    margin-right: 10px;
  }
  .activity-menu {
      padding: 0 5px;
      margin-right: 5px;
      cursor: pointer;
  }
  .activity-menu-list{
    width: 100%;
    padding-left:10px;
    box-sizing: border-box;
  }
  .work-hide{
    padding: 0 5px;
    line-height: 20px;
    position: absolute;
    left:0;
    top:0;
    background: rgba(0,0,0,.5);
  }
  .work-font-cover{
    padding:50px;
    box-sizing: border-box;
    white-space:pre-wrap;
    background: radial-gradient(circle, #1a2e3b, #353535);
    /* overflow-y: scroll; */
  }
</style>



// WEBPACK FOOTER //
// src/components/list/upload.vue